var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticStyle:{"color":"inherit","width":"0","height":"0","opacity":"0"},attrs:{"id":_vm.id_name},on:{"click":function($event){$event.stopPropagation();return _vm.generate($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }